// Angular Files
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

// Teller Online Library Files
import { TellerOnlineSiteMetadataService } from 'teller-online-libraries/core';

@Injectable({
    providedIn: 'root'
})
export class PortalFeatureGuardService {
    // Routes gated by the AuthenticatedUsers feature
    // (extracted from SessionAuthGuardService)
    private _authFeatureRoutes = [
        'sign-in',
        'sign-up',
        'reset-password',
        'forgot-password',
        'profile',
        'dashboard',
        'notification-settings',
        'change-password',
        'payment-history',
        'payment-methods',
        'payment-methods/:id',
        'personal-info',
        'schedule/:pageId/:bsiKey',
        'upcoming-payments',
        'user-history'
    ];

    // Routes gated by the ScheduledPayments feature
    private _scheduledPaymentRoutes = [
        'schedules',
        'schedule/:pageId/:bsiKey'
    ];

    constructor(
        private router: Router,
        private siteMetadataService: TellerOnlineSiteMetadataService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this._checkFeatures(route);
    }

    canActivateChild(route: ActivatedRouteSnapshot): boolean {
        return this._checkFeatures(route);
    }

    private _checkFeatures(route: ActivatedRouteSnapshot): boolean {
        const { path } = route.routeConfig;

        if (!this.siteMetadataService.authenticationEnabled
            && this._authFeatureRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        if (!this.siteMetadataService.scheduledPaymentsEnabled
            && this._scheduledPaymentRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
